import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {PipelineFlowTransport, PipelineFlowTransportEntity} from "../../../model/pipeline/pipeline-flow-transport";

export interface PipelineFlowTransportSelectorProps {
  regionId?: string
}

const getRegionIdParam = createParamSelector<PipelineFlowTransportSelectorProps | undefined, string | undefined>(params => params?.regionId);

export const pipelineFlowTransportsSelector = () => createSelector(
  [getUseQueryResultData<PipelineFlowTransport[]>, getRegionIdParam],
  (data, regionId) => {
    return selectPipelineFlowTransportsAndTransform(
      data ?? [], {
        regionId: regionId,
      }
    );
  }
);

export const pipelineFlowTransportSelector = () => createSelector(
  [getUseQueryResultData<PipelineFlowTransport>],
  (data) => {
    return data ? transformPipelineFlowTransport(data) : undefined;
  }
);

export const selectPipelineFlowTransports = (values?: PipelineFlowTransport[], selector?: PipelineFlowTransportSelectorProps): PipelineFlowTransport[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (v.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformPipelineFlowTransport = (value: PipelineFlowTransport): PipelineFlowTransportEntity => {
  return PipelineFlowTransportEntity.from(value)
}

export const selectPipelineFlowTransportsAndTransform = (values?: PipelineFlowTransport[], selector?: PipelineFlowTransportSelectorProps): PipelineFlowTransportEntity[] => {
  const selected = selectPipelineFlowTransports(values, selector);
  return selected.map(transformPipelineFlowTransport);
};
